<template>
	<label class="ms-checkbox" :class="[{ disabled: disabled }, customCssClass]">
		<div class="flex items-center">
			<input
				type="checkbox"
				class="mi-16 ms-checkbox-icon"
				:class="{ disabled: disabled }"
				:value="value"
				:checked="value"
				:disabled="disabled"
				v-on="listeners"
			/>
			<span class="checkmark">
				<div
					class="mi-16 checked-item" 
					:class="[
						{ focused: focused },
						{ active: value },
						{ disabled: disabled },
						isLineTick ? 'active-line-ticks' : '',
					]"
				>
					<div class="active-ticks" v-if="value"></div>
					<div
						:class="isLineTick ? 'line-ticks' : ''"
						v-else-if="isLineTick"
					></div>
				</div>
			</span>
			<span
				v-if="title"
				class="ms-checkbox--title"
				:class="{ 'font-bold': fontBold }"
				v-html="title"
			></span>
		</div>
	</label>
</template>
<script>
export default {
	name: 'msCheckbox',
	props: {
		value: {},
		title: {
			default: null,
			type: String,
		},
		disabled: {
			default: false,
			type: Boolean,
		},
		fontBold: {
			default: false,
			type: Boolean,
		},
		customCssClass: {
			default: '',
			type: String,
		},
		//Có sử dụng dấu gạch - ở checkbox hay không
		isLineTick: {
			default: false,
			type: Boolean,
		},
	},
	methods: {
		onFocus(e) {
			const me = this;
			me.focused = true;
		},
		onBlur(e) {
			const me = this;
			me.focused = false;
		},
	},
	data() {
		return {
			focused: false,
		};
	},
	computed: {
		listeners() {
			const me = this;
			return {
				click: (event) => {
					me.$emit('click', event);
				},
				input: (event) => {
					me.$emit('input', !me.value);
				},
				change: (event) => {
					me.$emit('change', me.value);
				},
				focus: (event) => {
					me.onFocus(event);
				},
				blur: (event) => {
					me.onBlur(event);
				},
			};
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msCheckbox.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msCheckbox.scss';
}
</style>